export default "__VITE_ASSET__Cmd2qMag__"